import { TemplateNavHeaderStyles } from "./NavHeader.styles"

const t = document.createElement('template')
t.innerHTML = `
<!-- Mobile Menu: Tabs + Menu -->
<div id="nav-mobile-panel" class="d-md-none bg-white border-top px-3 pt-2 closed">
  <ul class="nav flex-column">
    <slot name="navMobileItems"></slot>
    <!--
    TODO!!!
    <li
      v-for="tab in tabs"
      :key="tab"
      class="nav-item"
      :class="{ 'fw-bold text-primary': activeTab === tab }"
    >
      <a href="#" class="nav-link" @click.prevent="setActive(tab)">
        {{ tab }}
      </a>
    </li>
    -->
    <hr />
    <li class="nav-item"><a class="nav-link" href="#">About</a></li>
    <li class="nav-item"><a class="nav-link" href="#">Contact</a></li>
    <li class="nav-item"><a class="nav-link" href="#">Careers</a></li>
  </ul>
</div>
`

class NavHeaderMobile extends HTMLElement {
  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(TemplateNavHeaderStyles.content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))
  }

  connectedCallback() {
    console.log('NavHeaderMobile connectedCallback', this)
  }

  static get observedAttributes() {
    return ['isopen']
  }

  attributeChangedCallback(name: string, oldValue: string, newValue: string) {

    if (name === 'isopen') {
      const isOpen = newValue === 'true';
      const navMobilePanel = this.shadowRoot?.getElementById('nav-mobile-panel');
      if (navMobilePanel) {
        if (isOpen) {
          navMobilePanel.classList.remove('closed');
          navMobilePanel.classList.add('open');
        } else {
          navMobilePanel.classList.add('closed');
          navMobilePanel.classList.remove('open');
        }
      }
    }
  }
}

if (!customElements.get('ts-navheader-mobile')) {
  customElements.define('ts-navheader-mobile', NavHeaderMobile)
}
export { NavHeaderMobile }
